// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-form-field{
    width: 100%;
}
form small.error{
    position: relative;
    top: -24px;
}
.phone{
    color: #f44336;
}

.agent-card-header p{
    margin: 0;
}
a{
    color: #DA512D;
    text-decoration: none;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFnZW50LWFkZC5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksV0FBVztBQUNmO0FBQ0E7SUFDSSxrQkFBa0I7SUFDbEIsVUFBVTtBQUNkO0FBQ0E7SUFDSSxjQUFjO0FBQ2xCOztBQUVBO0lBQ0ksU0FBUztBQUNiO0FBQ0E7SUFDSSxjQUFjO0lBQ2QscUJBQXFCO0FBQ3pCIiwiZmlsZSI6ImFnZW50LWFkZC5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLm1hdC1mb3JtLWZpZWxke1xuICAgIHdpZHRoOiAxMDAlO1xufVxuZm9ybSBzbWFsbC5lcnJvcntcbiAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgdG9wOiAtMjRweDtcbn1cbi5waG9uZXtcbiAgICBjb2xvcjogI2Y0NDMzNjtcbn1cblxuLmFnZW50LWNhcmQtaGVhZGVyIHB7XG4gICAgbWFyZ2luOiAwO1xufVxuYXtcbiAgICBjb2xvcjogI0RBNTEyRDtcbiAgICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG59Il19 */`, "",{"version":3,"sources":["webpack://./src/app/secure/agent-add/agent-add.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA,osBAAosB","sourcesContent":[".mat-form-field{\n    width: 100%;\n}\nform small.error{\n    position: relative;\n    top: -24px;\n}\n.phone{\n    color: #f44336;\n}\n\n.agent-card-header p{\n    margin: 0;\n}\na{\n    color: #DA512D;\n    text-decoration: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
